import { CIcon } from '~/icons/types'

export const ciForklifts: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.5 18.94h-4.119V3.898a.5.5 0 0 0-1 0v8.03h-1.273v-.457a.5.5 0 0 0-.5-.5h-1.56l-.527-4.567a4.022 4.022 0 0 0-3.989-3.506H7.67a2.132 2.132 0 0 0-2.132 2.127v5.946H2.482a2.5 2.5 0 0 0-2.294 1.532 2.466 2.466 0 0 0-.188.95v5.014a.5.5 0 0 0 .5.5h1.978a2.629 2.629 0 0 0 5.165 0h2.133a2.63 2.63 0 0 0 5.164 0h1.668a.5.5 0 0 0 .5-.5v-.594h1.273v1.567a.5.5 0 0 0 .5.5H23.5a.5.5 0 1 0 0-1ZM6.538 5.025A1.134 1.134 0 0 1 7.67 3.898h2.862a3.025 3.025 0 0 1 3 2.632l.557 4.825-.413.64-1.46-1.523.445-.335a.5.5 0 1 0-.6-.8l-1.845 1.388a.5.5 0 0 0 .6.8l.595-.447 1.707 1.78-.353.547H8.219l-1.681-2.107V5.025ZM5.06 20.103a1.633 1.633 0 1 1 0-3.266 1.633 1.633 0 0 1 0 3.266Zm7.3 0a1.633 1.633 0 1 1 1.153-.477 1.634 1.634 0 0 1-1.155.477h.002Zm3.75-2.136h-1.17a2.63 2.63 0 0 0-5.164 0H7.642a2.63 2.63 0 0 0-5.163 0H1v-4.514a1.483 1.483 0 0 1 1.482-1.482H5.8l1.79 2.24a.5.5 0 0 0 .391.188h5.056a.5.5 0 0 0 .42-.228l1.421-2.2h1.233l-.001 5.996Zm2.273-1.094h-1.275v-3.945h1.273l.002 3.945Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'forklifts',
  type: 'thin'
}
